import { Injectable } from '@angular/core';
import { CanActivate, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { VendorServiceService } from '@viso/web/vendor/shared/data-access';

@Injectable({
  providedIn: 'root',
})
export class OnBoardGuard implements CanActivate {
  constructor(
    private vendorService: VendorServiceService,
    private router: Router
  ) {}

  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.vendorService.getAllVendorService().pipe(
      map((services) => {
        const serviceExist = services.length === 0;
        this.router.getCurrentNavigation().extras.replaceUrl = true;
        return serviceExist || this.router.createUrlTree(['/event/list']);
      })
    );
  }
}
